import request from '@/plugin/axios'

export function getOrganizationList (pageable) {
  return request({
    url: '/api/admin/organization',
    method: 'get',
    params: pageable
  })
}

export function createOrganization (organization) {
  return request({
    url: '/api/admin/organization',
    method: 'post',
    data: organization
  })
}

export function updateOrg (data) {
  return request({
    url: '/api/admin/organization/' + data.id,
    method: 'put',
    data: data
  })
}
export function getChildOrganizationList (pageable) {
  return request({
    url: '/api/admin/child_organization',
    method: 'get',
    params: pageable
  })
}
